<template>
    <div class="rvs-ow pt-4">
        <div class="offset-4 col-span-8">
            <div class="flex items-start justify-end">
                <div class="flex-grow-0 mr-4 user-message">
                    <p class="p-4 m-0"> {{ data }} </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: String,
    }
};
</script>